/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { IncomingContent } from '@/data/types/IncomingContent';
import { Layout } from '@/data/types/Layout';

export const getDpFanProfilePage = (_: IncomingContent): Layout => ({
	name: 'HomeStack',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		first: [{ name: 'DpFanProfilePage', id: 'dp-fan-profile-page' }],
		second: [],
		footer: [{ name: 'Footer', id: 'footer' }],
	},
});
